// @ts-nocheck
import React, { createContext, useContext } from 'react';
import { useLogoLibrary } from '@/hooks/query/logoLibrary';

const LogoLibraryContext = createContext();

export function LogoLibraryProvider({ ...props }) {
  const { data: logos, isLoading: isLogosLoading } = useLogoLibrary();

  const state = { logos, isLogosLoading };

  return <LogoLibraryContext.Provider value={state} {...props} />;
}

export const useLogoLibraryContext = () => useContext(LogoLibraryContext);
